<template>
  <v-container id="cupon" tag="section">
    <base-v-component heading="Cupones " />
    <base-material-card
      color="indigo"
      icon="mdi-basket"
      inline
      class="px-5 py-3"
    >
      <v-card-text>
        <v-container grid-list-md>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="cupon.nombre"
                label="Nombre"
                @input="$v.cupon.nombre.$touch()"
                @blur="$v.cupon.nombre.$touch()"
                :error-messages="nombreErrors"
                ref="nombreReferencia"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field v-model="cupon.descripcion" label="Descripción">
              </v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="cupon.cupon"
                label="Cupón"
                append-icon="mdi-tools"
                @click:append="generarCupon"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-select
                v-model="cupon.usosLimite"
                :items="usosLimiteItems"
                label="Número de usos"
                messages="A quien afectará el número de usos"
              />
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field
                v-model="cupon.usos"
                label="Número de usos"
                messages="Menor o igual que cero usos ilimitados"
                type="number"
                step="1"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4">
              <v-text-field
                label="Inicio"
                type="datetime-local"
                v-model="inicioModel"
                placeholder="dd-mm-yyyy hh:mm"
                value=""
                min="1997-01-01"
                max="2030-12-31"
              />
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                label="Fin"
                v-model="finModel"
                type="datetime-local"
                placeholder="dd-mm-yyyy hh:mm"
                value=""
                min="1997-01-01"
                max="2030-12-31"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4">
              <v-select
                v-model="cupon.tipoCupon"
                :items="tiposCupones"
                label="Tipo de cupón"
              />
            </v-col>
            <v-col
              cols="12"
              md="2"
              v-if="cupon.tipoCupon == 'descuento_porcentaje'"
            >
              <v-text-field
                v-model="cupon.descuentoPorcentaje"
                append-icon="mdi-percent"
                type="number"
                step="1"
                label="Porcentaje de descuento"
              />
            </v-col>
            <v-col
              cols="12"
              md="2"
              v-if="cupon.tipoCupon == 'descuento_absoluto'"
            >
              <v-text-field
                v-model="cupon.descuentoAbsoluto"
                append-icon="mdi-currency-eur"
                type="number"
                step="0.05"
                label="Valor de descuento"
              />
            </v-col>

            <v-col cols="12" md="6" v-if="cupon.tipoCupon == 'producto'">
              <v-select
                multiple
                :items="$store.getters['productos/getProductosSelect']"
                v-model="cupon.descuentoProducto"
                append-icon="mdi-food"
                label="Productos"
              />
            </v-col>
            <v-col cols="12" md="6" v-if="cupon.tipoCupon == 'categoria'">
              <v-select
                multiple
                :items="$store.getters['categorias/getCategoriasSelect']"
                v-model="cupon.descuentoCategoria"
                append-icon="mdi-food"
                label="Categorias"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="save" :loading="loadingForm"
          >Guardar</v-btn
        >
      </v-card-actions>
    </base-material-card>
  </v-container>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { mapState, mapGetters, mapActions } from "vuex";
import moment from "moment-timezone";
export default {
  mixins: [validationMixin],
  validations: {
    cupon: { nombre: { required, minLength: minLength(2) } },
  },
  data() {
    return {
      loadingForm: false,
      cupon: {
        id: null,
        nombre: "",
        descripcion: "",
        cupon: "",
        usosLimite: "usuario", //usuario, general
        usos: "0",
        tipoCupon: null,
        fechaInicio: "", //en unix
        fechaFin: "", //en unix
        descuentoCategoria: [],
        descuentoProducto: [],
        descuentoPorcentaje: 0,
        descuentoAbsoluto: 0,
      },
      inicioModel: "",
      finModel: "",
    };
  },
  computed: {
    ...mapState({
      idiomas: "idiomas",
      langDefecto: "langDefecto",
      usosLimiteItems: (state) => state.cupones.usosLimite,
      usosItems: (state) => state.cupones.usos,
      cupones: (state) => state.cupones.cupones,
      tiposCupones: (state) => state.cupones.tiposCupones,
    }),
    diasSemanaDigito() {
      return this.$store.state.negocios.diasSemana.map((d, i) => {
        return {
          text: d.text,
          value: i,
        };
      });
    },
    itemsCondiciones() {
      return this.itemsCondicionesBruto.filter((i) => {
        return i.tipos && Array.isArray(i.tipos) && i.tipos.includes(this.tipo);
      });
    },
    langSeleccionado: {
      get() {
        return this.$store.state.langSeleccionado;
      },
      set(v) {
        this.$store.commit("setLangSeleccionado", v);
      },
    },
    ...mapGetters({
      negocio: "app/negocioGestObj",
      categorias: "categorias/getCategoriasSelect",
      productos: "productos/getProductosSelect",
      restaurantes: "restaurantes/getRestaurantesSelect",
      caracteristicas: "caracteristicas/getCaracteristicasSelectGrupo",
    }),
    nombreErrors() {
      const errors = [];
      if (!this.$v.cupon.nombre.$dirty) return errors;
      !this.$v.cupon.nombre.required && errors.push("Nombre obligatorio.");
      !this.$v.cupon.nombre.minLength && errors.push("Nombre demasiado corto.");
      return errors;
    },
  },
  methods: {
    generarCupon() {
      this.cupon.cupon = (Math.random() + 1)
        .toString(36)
        .substring(4)
        .toUpperCase();
    },
    goListado() {
      let str = "/admin/gest/" + this.negocio.id + "/cupones/";
      this.$router.push(str);
    },
    addCupon() {
      let _vm = this;

      return this.$store
        .dispatch("cupones/addCupon", {
          ...this.cupon,
          fechaInicio: moment(this.inicioModel).unix(),
          fechaFin: moment(this.finModel).unix(),
        })
        .then(() => {
          _vm.goListado();
        });
    },
    save() {
      let _vm = this;
      this.$v.$touch();
      if (!this.$v.$invalid) {
        console.log({
          ...this.cupon,
          inicio: moment
            .tz(this.inicioModel, "Europe/Madrid")
            .format("DD-MM-YYYY HH:mm"),
          fin: moment
            .tz(this.finModel, "Europe/Madrid")
            .format("DD-MM-YYYY HH:mm"),
        });

        this.loadingForm = true;
        this.addCupon()
          .then((res) => {
            _vm.$store.commit("snackbar/setMensajeSuccess", {
              msj: "Cupón añadido con éxito",
            });
          })
          .catch((error) => {
            console.log(error);
            _vm.$store.commit("snackbar/setMensajeDanger", {
              msj: "Error al guardar el producto",
            });
          })
          .finally(() => {
            _vm.loadingForm = false;
          });
      }
    },
    goAdd() {
      let str = "/admin/gest/" + this.negocio.id + "/cupones/add";
      this.$router.push(str);
    },
  },
  created() {},
  mounted() {
    const id = this.$route.params.idcupon;
    if (id) {
      const found = this.cupones.find((e) => e.id == id);
      console.log(found);

      if (found) {
        this.cupon = { ...found };
        this.cupon.id = id;
        this.inicioModel = moment
          .unix(found.fechaInicio)
          .tz("Europe/Madrid")
          .format("YYYY-MM-DDTHH:mm");
        this.finModel = moment
          .unix(found.fechaFin)
          .tz("Europe/Madrid")
          .format("YYYY-MM-DDTHH:mm");
      } else {
        this.goAdd();
      }
    }
  },
};
</script>

<style>
</style>